import React from 'react';
import { connect } from 'react-redux';
import { FontIcon, FlatButton, RaisedButton } from 'material-ui';
import pluralize from 'pluralize';
import R from 'ramda';
// Basic Account Partners Threshold
const basicNo = 20;
const SuccessPage = ({ contractsToBeCreated, sentPartnersLength, onRequestClose, contractingPartners, billingPlan, newPartnersSelected, isShellAccount, templates }, { router }) => {
  const contractingPartnersLength = R.propOr(0, 'length', contractingPartners) + (newPartnersSelected.length || 0);
  return (
    <div style={{ marginTop: '32px', textAlign: 'center' }}>
      <FontIcon className="tc-icon-paperplane" color="#00bcd4" style={{ fontSize: '128px' }} />
      <p style={{ fontSize: '16px', margin: '16px' }}>
        Congratulations!
        <br/>
        <br/>
        <p style={{ marginBottom: '0' }}>We have sent your rates&nbsp;to&nbsp;{sentPartnersLength}&nbsp;{pluralize('partner', sentPartnersLength)}.</p>
      </p>
      {
        isShellAccount && R.isEmpty(templates) ? (<p>
          We've also saved these rates as a template, so you can send them to other partners and access them in the future.
        </p>) : <p>If you need to send updates in the future, simply edit the contract or template.</p>
      }
      {
        Boolean(billingPlan === 'basic' && contractingPartnersLength) && (
          <div style={{ padding: '24px' }}>
            <div style={{ fontStyle: 'italic' }}>{`You have used ${contractingPartnersLength}/${basicNo} of your free contracting partners under the Basic Plan.`}</div>
            <div style={{ fontStyle: 'italic' }}>You can
              &nbsp;<RaisedButton label="upgrade" secondary onTouchTap={() => this.context.router.push('/upgrade')} />&nbsp;
              to send your contracts to all of the partners you work with.</div>
          </div>
        )
      }
      <FlatButton
        label="Go to my Contract List"
        labelStyle={{ color: '#fb5500' }}
        onTouchTap={() => {
          if (onRequestClose) onRequestClose();
          router.push('/contracting/contract-list/all%20contracts');
        }}
      />
      <FlatButton
        label="Keep working on my templates"
        secondary
        onTouchTap={() => {
          if (onRequestClose) onRequestClose();
          router.push('/contracting/template-list');
        }}
      />
    </div>
  );
};
const mapStateToProps = ({ user, contracting }) => ({
  billingPlan: user.get('billingPlan'),
  isShellAccount: user.get('contractingShell'),
  templates: contracting.templateList.get('templates').toJS(),
  contractingPartners: contracting.sendToPartners.get('contractingPartners').toJS().filter(obj => obj.paidBy === 'Supplier'),
  newPartnersSelected: contracting.sendToPartners.get('newPartnersSelected').toJS(),
});
SuccessPage.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps)(SuccessPage);



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-wizard/success-page.jsx